var map = {
	"./cards_back.png": 31100,
	"./cards_back.svg": 72506,
	"./flags/de.svg": 67506,
	"./flags/en.svg": 97882,
	"./flags/sv.svg": 92680,
	"./menu/activity.svg": 53210,
	"./menu/alert-triangle.svg": 12206,
	"./menu/award.svg": 86076,
	"./menu/book.svg": 65462,
	"./menu/check-circle.svg": 59272,
	"./menu/check.svg": 13899,
	"./menu/chevron-down.svg": 68423,
	"./menu/chevron-left.svg": 53656,
	"./menu/chevron-right.svg": 92199,
	"./menu/chevron-up.svg": 11224,
	"./menu/chevrons-left.svg": 99285,
	"./menu/chevrons-right.svg": 24376,
	"./menu/circle.svg": 70517,
	"./menu/dollar-sign.svg": 53991,
	"./menu/edit.svg": 40465,
	"./menu/eye.svg": 20976,
	"./menu/fast-forward.svg": 33483,
	"./menu/file-plus.svg": 47988,
	"./menu/file-text.svg": 97025,
	"./menu/games.svg": 8654,
	"./menu/home.svg": 45140,
	"./menu/log-in.svg": 22147,
	"./menu/log-out.svg": 95014,
	"./menu/message-square.svg": 6070,
	"./menu/pie-chart.svg": 74434,
	"./menu/play.svg": 583,
	"./menu/plus.svg": 87425,
	"./menu/refresh-cw.svg": 64453,
	"./menu/settings.svg": 59150,
	"./menu/shopping-cart.svg": 6684,
	"./menu/trash.svg": 5353,
	"./menu/user.svg": 8172,
	"./menu/users.svg": 61063,
	"./menu/x-circle.svg": 22140
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36869;